import { Pipe, PipeTransform } from '@angular/core';
import { MenuListItem } from '@atpco/hub-ui';

@Pipe({
  name: 'getSelectDisplayValue'
})
export class GetSelectDisplayValuePipe implements PipeTransform {
  transform(selectedItems: MenuListItem[], fieldName: string, placeholder: string): string {
    if (selectedItems.length === 0) {
      return placeholder;
    } else if (selectedItems.length === 1) {
      return selectedItems[0].name;
    } else {
      return `${selectedItems.length} ${fieldName}s selected`;
    }
  }
}